module.exports = __webpack_public_path__ + "img/chenguo_zhaunti.e69d446.png";